import React from 'react'
import Button from '@mui/material/Button'
import CallEndIcon from '@mui/icons-material/CallEnd'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import './OutgoingCall.scss'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}

const TIMEOUT_MS = 50000

export default function OutgoingCall ({
  outgoingCall,
  calleeName,
  cancelCall,
  onTimeout
}) {
  const { t } = useTranslation()

  React.useEffect(() => {
    let timer
    if (outgoingCall) {
      timer = setTimeout(() => {
        onTimeout()
      }, TIMEOUT_MS)
    }
    return () => clearTimeout(timer)
  }, [outgoingCall])

  return (
    <Modal open={outgoingCall}>
      <Box sx={style}>
        <div className="outgoingCall">
          <div className="outgoingCall__content">
            <p className="outgoingCall__content__text">
              {t('Calling')}
              <br />
              <span>{calleeName}</span>
            </p>
            <div className="outgoingCall__content__dots">
              <span className="outgoingCall__content__dots__dot" />
              <span className="outgoingCall__content__dots__dot" />
              <span className="outgoingCall__content__dots__dot" />
            </div>
            <div className="outgoingCall__content__buttons">
              <Button
                className="outgoingCall__content cancelCall"
                startIcon={<CallEndIcon />}
                onClick={() => cancelCall()}
              >
                {t('Cancel')}
              </Button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  )
}

OutgoingCall.propTypes = {
  outgoingCall: PropTypes.bool,
  calleeName: PropTypes.string,
  cancelCall: PropTypes.func,
  onTimeout: PropTypes.func
}
